import { Service } from "@warda/library-ui/contexts/AppWebSocketContext";
import { getPathCurrentUrl } from "@warda/library-ui/layout/Login";
import { BASE_URL, PRODUCT_ID } from "../constants/keys";
export const fetchAnonymous = async ({ url, method = "GET", jsonBody = {}, addHeaders = {}, }) => {
    try {
        const headers = {
            "Content-Type": "application/json",
            ...addHeaders,
        };
        const options = method !== "GET" && method !== "HEAD"
            ? {
                credentials: "include",
                method,
                headers,
                body: JSON.stringify(jsonBody),
            }
            : { credentials: "include", method, headers };
        const response = await fetch(url, options);
        const { status } = response;
        if (status >= 400)
            throw { status, response };
        return await response.json();
    }
    catch (err) {
        throw err;
    }
};
export const getPasswordPolicy = async (groupId) => {
    const res = await fetchAnonymous({
        url: `${BASE_URL}/${Service.USERS}/passwordPolicy/${groupId}`,
        method: "GET",
    });
    return res;
};
export const onChoosePassword = async ({ authTmpCode, authGroupId, username, password, }) => {
    let url;
    let jsonBody;
    if (getPathCurrentUrl() === "choosepassword") {
        url = `${BASE_URL}/${Service.USERS}/token/user/activate`;
        jsonBody = {
            email: username,
            temporaryPassword: authTmpCode,
            newPassword: password,
            groupId: authGroupId,
            applicationId: PRODUCT_ID,
        };
    }
    else {
        url = `${BASE_URL}/${Service.USERS}/confirmForgotPassword`;
        jsonBody = {
            email: username,
            confirmationCode: authTmpCode,
            newPassword: password,
            groupId: authGroupId,
            applicationId: PRODUCT_ID,
        };
    }
    await fetchAnonymous({
        url,
        method: "POST",
        jsonBody,
    });
    return { success: true, message: "" };
};
export const onDemandPassword = async ({ tenantId, username, }) => {
    const url = `${BASE_URL}/${Service.USERS}/forgotPassword`;
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            email: username,
            tenantId,
            applicationId: PRODUCT_ID,
        }),
    });
    const status = res.status;
    const { error, message, code } = await res.json();
    return { success: status < 400, message: error || message || code };
};
